var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "pb-30" },
    [
      _c(
        "md-card",
        { staticClass: "mt-20" },
        [
          _c(
            "md-card-content",
            { staticClass: "ask-subject", style: { padding: "9px" } },
            [
              _c("div", { staticClass: "card-inline" }, [
                _c("p", {
                  staticClass: "ask-status",
                  domProps: { textContent: _vm._s(_vm.status) }
                }),
                _vm._v(" "),
                _c(
                  "ul",
                  {
                    staticClass:
                      "list-inline align-right btnleftspaceremove mtm-3"
                  },
                  [
                    _c(
                      "li",
                      [
                        !_vm.ask.isClose
                          ? _c(
                              "md-button",
                              {
                                staticClass:
                                  "md-raised md-round md-accent capitalize",
                                on: {
                                  click: function($event) {
                                    return _vm.doInteraction("close")
                                  }
                                }
                              },
                              [_vm._v("Close")]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        !_vm.ask.isClose
                          ? _c(
                              "md-button",
                              {
                                staticClass:
                                  "md-raised md-round md-accent capitalize",
                                on: {
                                  click: [
                                    function($event) {
                                      return _vm.doInteraction("comment")
                                    },
                                    function($event) {
                                      return _vm.expand("comment")
                                    }
                                  ]
                                }
                              },
                              [_vm._v("Comment")]
                            )
                          : _vm._e()
                      ],
                      1
                    )
                  ]
                )
              ])
            ]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "md-card",
        { staticClass: "mt-30" },
        [
          _c(
            "md-card-header",
            { staticClass: "ask-subject", style: _vm.communityStyle },
            [
              _c("ul", { staticClass: "list-inline mb-0" }, [
                _c("li", [
                  _vm._v(
                    _vm._s(
                      _vm.$lodash.has(_vm.community, "name")
                        ? _vm.community.name +
                            ": " +
                            (_vm.ask.request && _vm.ask.request.subject
                              ? _vm.ask.request.subject
                              : "N/A")
                        : "N/A"
                    )
                  )
                ]),
                _vm._v(" "),
                _vm.ask.request &&
                _vm.ask.request.comment &&
                _vm.ask.request.comment.length
                  ? _c("li", { staticClass: "count" }, [
                      _vm._v(_vm._s(_vm.ask.request.comment.length))
                    ])
                  : _vm._e()
              ])
            ]
          )
        ],
        1
      ),
      _vm._v(" "),
      [
        _c(
          "md-card",
          [
            _c(
              "md-card-content",
              { staticClass: "ask-detail-section ask-text-content" },
              [
                _c("div", { staticClass: "ask-detail" }, [
                  _c("div", { staticClass: "inline-grid" }, [
                    _c("div", { staticClass: "ask-member-details" }, [
                      _vm.ask.request &&
                      _vm.ask.request.first &&
                      _vm.ask.request.last
                        ? _c("div", { staticClass: "edit-ask" }, [
                            _vm.ask.memberId
                              ? _c(
                                  "span",
                                  {
                                    staticClass: "display-link",
                                    on: {
                                      click: function($event) {
                                        return _vm.goToProfile(_vm.ask.memberId)
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.ask.request.first +
                                          " " +
                                          _vm.ask.request.last
                                      )
                                    )
                                  ]
                                )
                              : _vm.ask.request.first && _vm.ask.request.last
                              ? _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.ask.request.first +
                                        " " +
                                        _vm.ask.request.last
                                    )
                                  )
                                ])
                              : _c("span", [_vm._v(_vm._s(_vm.ask.email))])
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.ask.email
                        ? _c("span", [_vm._v(_vm._s(_vm.ask.email))])
                        : _vm._e()
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "inline-grid" }, [
                    _c("p", { staticClass: "ask-header" }, [_vm._v("Channel")]),
                    _vm._v(" "),
                    _c("span", [
                      _vm._v(
                        _vm._s(
                          _vm.ask.request && _vm.ask.request.channelType
                            ? _vm.ask.request.channelType
                            : "N/A"
                        )
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "inline-grid" }, [
                    _c("p", { staticClass: "ask-header" }, [
                      _vm._v("Request Received")
                    ]),
                    _vm._v(" "),
                    _vm.ask.createdAt
                      ? _c("span", [
                          _vm._v(
                            _vm._s(_vm._f("momentDate")(_vm.ask.createdAt))
                          )
                        ])
                      : _c("span", [_vm._v("N/A")])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "inline-grid" }, [
                    _c("p", { staticClass: "ask-header" }, [
                      _vm._v("Advisors Asked")
                    ]),
                    _vm._v(" "),
                    _c("span", [_vm._v("N/A")])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "inline-grid" }, [
                    _c("p", { staticClass: "ask-header" }, [
                      _vm._v("Advisor Feedback")
                    ]),
                    _vm._v(" "),
                    _c("span", [_vm._v("N/A")])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "inline-grid" }, [
                    _c("p", { staticClass: "ask-header" }, [
                      _vm._v("Member Role")
                    ]),
                    _vm._v(" "),
                    _vm.ask.request &&
                    _vm.ask.request.dynamicFields &&
                    _vm.ask.request.dynamicFields.memberRole
                      ? _c("span", { staticClass: "ask-member-role" }, [
                          _c("b", [
                            _vm._v(
                              _vm._s(_vm.ask.request.dynamicFields.memberRole)
                            )
                          ])
                        ])
                      : _c("span", [_vm._v("N/A")])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "inline-grid" }, [
                    _c("p", { staticClass: "ask-header" }, [
                      _vm._v("Advice Area")
                    ]),
                    _vm._v(" "),
                    _vm.ask.request &&
                    _vm.ask.request.dynamicFields &&
                    _vm.ask.request.dynamicFields.adviceArea
                      ? _c("span", { staticClass: "ask-member-role" }, [
                          _c("b", [
                            _vm._v(
                              _vm._s(_vm.ask.request.dynamicFields.adviceArea)
                            )
                          ])
                        ])
                      : _c("span", [_vm._v("N/A")])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "inline-grid" }, [
                    _c("p", { staticClass: "ask-header" }, [
                      _vm._v("Request Sent")
                    ]),
                    _vm._v(" "),
                    _c("span", [_vm._v("N/A")])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "inline-grid" }, [
                    _c("p", { staticClass: "ask-header" }, [
                      _vm._v("Responses")
                    ]),
                    _vm._v(" "),
                    _c("span", [_vm._v("N/A")])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "inline-grid" }, [
                    _c("p", { staticClass: "ask-header" }, [
                      _vm._v("Member Feedback")
                    ]),
                    _vm._v(" "),
                    _c("span", [_vm._v("N/A")])
                  ])
                ])
              ]
            )
          ],
          1
        )
      ],
      _vm._v(" "),
      _c(
        "md-card",
        { staticClass: "mt-30" },
        [
          _c(
            "md-card-header",
            {
              staticClass: "md-title m-left-5",
              attrs: { "md-alignment": "space-between" }
            },
            [_vm._v("Request")]
          ),
          _vm._v(" "),
          _c("md-card-content", { staticClass: "card-content" }, [
            _c(
              "form",
              [
                _c("md-field", { staticClass: "create-ask m-left-5" }, [
                  _c("label", { staticClass: "card-header" }, [
                    _vm._v("Subject")
                  ]),
                  _vm._v(" "),
                  _vm.ask.request && _vm.ask.request.subject
                    ? _c(
                        "p",
                        {
                          attrs: {
                            name: "subject",
                            placeholder: "Request summary..."
                          }
                        },
                        [_vm._v(_vm._s(_vm.ask.request.subject))]
                      )
                    : _c("p", [_vm._v(" N/A ")])
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass:
                      "create-ask ask-description-area form-group m-left-5"
                  },
                  [
                    _c("label", { staticClass: "card-header" }, [
                      _vm._v("Description")
                    ]),
                    _vm._v(" "),
                    _vm.askRequestDetail
                      ? _c(
                          "p",
                          {
                            staticClass: "description font-16",
                            attrs: {
                              id: "textarea",
                              placeholder: "Describe the request..."
                            }
                          },
                          [_vm._v(" " + _vm._s(_vm.askRequestDetail) + " ")]
                        )
                      : _c("p", [_vm._v(" N/A ")])
                  ]
                )
              ],
              1
            )
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "md-card",
        { staticClass: "mt-30" },
        [
          _c(
            "md-card-expand",
            [
              _c(
                "md-card-actions",
                { attrs: { "md-alignment": "space-between" } },
                [
                  _c(
                    "md-card-expand-trigger",
                    [
                      _c("md-button", { staticClass: "expand-button-size" }, [
                        _c(
                          "strong",
                          {
                            staticClass: "upper-word",
                            on: {
                              click: function($event) {
                                return _vm.expand("tag")
                              }
                            }
                          },
                          [
                            _vm._v("Tags "),
                            _c("span", {
                              domProps: {
                                textContent: _vm._s(
                                  "(" +
                                    (_vm.$lodash.has(_vm.ask.tags, 0)
                                      ? _vm.ask.tags.length
                                      : "0") +
                                    ")"
                                )
                              }
                            })
                          ]
                        )
                      ])
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "md-card",
        { staticClass: "mt-30 adviser-section" },
        [
          _c(
            "md-card-expand",
            [
              _c(
                "md-card-actions",
                { attrs: { "md-alignment": "space-between" } },
                [
                  _c(
                    "md-card-expand-trigger",
                    [
                      _c("md-button", { staticClass: "expand-button-size" }, [
                        _c(
                          "strong",
                          {
                            staticClass: "upper-word",
                            on: {
                              click: function($event) {
                                return _vm.expand("adviser")
                              }
                            }
                          },
                          [
                            _vm._v("Advisers "),
                            _c("span", {
                              domProps: { textContent: _vm._s("(0)") }
                            })
                          ]
                        )
                      ])
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "md-card",
        { staticClass: "mt-30", attrs: { id: "response-section" } },
        [
          _c(
            "md-card-expand",
            [
              _c(
                "md-card-actions",
                { attrs: { "md-alignment": "space-between" } },
                [
                  _c(
                    "md-card-expand-trigger",
                    [
                      _c("md-button", { staticClass: "expand-button-size" }, [
                        _c(
                          "strong",
                          {
                            staticClass: "upper-word",
                            on: {
                              click: function($event) {
                                return _vm.expand("response")
                              }
                            }
                          },
                          [
                            _vm._v("Responses "),
                            _c("span", {
                              domProps: { textContent: _vm._s("(0)") }
                            })
                          ]
                        )
                      ])
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "md-card",
        { staticClass: "mt-30", attrs: { id: "response-section" } },
        [
          _c(
            "md-card-expand",
            [
              _c(
                "md-card-actions",
                { attrs: { "md-alignment": "space-between" } },
                [
                  _c(
                    "md-card-expand-trigger",
                    [
                      _c("md-button", { staticClass: "expand-button-size" }, [
                        _c(
                          "strong",
                          {
                            staticClass: "upper-word",
                            on: {
                              click: function($event) {
                                return _vm.expand("feedback")
                              }
                            }
                          },
                          [
                            _vm._v("Feedback "),
                            _c("span", {
                              domProps: { textContent: _vm._s("(0)") }
                            })
                          ]
                        )
                      ])
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      [
        _vm.ask.request
          ? _c(
              "div",
              { staticClass: "mt-30" },
              [
                _c(
                  "md-card",
                  { attrs: { id: "commentDivSection" } },
                  [
                    _c(
                      "md-card-expand",
                      [
                        _c(
                          "md-card-actions",
                          {
                            ref: "commentDivSection",
                            attrs: { "md-alignment": "space-between" }
                          },
                          [
                            _c(
                              "md-card-expand-trigger",
                              [
                                _c(
                                  "md-button",
                                  { staticClass: "expand-button-size" },
                                  [
                                    _c("strong", [
                                      _c(
                                        "span",
                                        {
                                          staticClass: "upper-word",
                                          on: {
                                            click: function($event) {
                                              return _vm.expand("comment")
                                            }
                                          }
                                        },
                                        [
                                          _vm._v("Comments "),
                                          _c("span", [
                                            _vm._v(
                                              "(" +
                                                _vm._s(
                                                  _vm.ask.request &&
                                                    _vm.ask.request.comments
                                                    ? _vm.ask.request.comments
                                                        .length
                                                    : 0
                                                ) +
                                                ")"
                                            )
                                          ])
                                        ]
                                      )
                                    ])
                                  ]
                                )
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "md-card-expand-content",
                          [
                            _c("md-card-content", { staticClass: "comments" }, [
                              _c(
                                "div",
                                { staticClass: "comments" },
                                _vm._l(_vm.sortComments, function(
                                  comment,
                                  index
                                ) {
                                  return _vm.ask.request.comments &&
                                    _vm.ask.request.comments.length
                                    ? _c(
                                        "div",
                                        {
                                          key: "comment-" + index,
                                          staticClass: "activity"
                                        },
                                        [
                                          _c("b", [
                                            _vm._v(
                                              _vm._s(
                                                _vm._f("momentDate")(
                                                  comment.when
                                                )
                                              ) +
                                                " - " +
                                                _vm._s(comment.memberName)
                                            )
                                          ]),
                                          _vm._v(" "),
                                          _c(
                                            "p",
                                            { staticClass: "ask-description" },
                                            [_vm._v(_vm._s(comment.comment))]
                                          )
                                        ]
                                      )
                                    : _vm._e()
                                }),
                                0
                              ),
                              _vm._v(" "),
                              _c("div", [
                                _c(
                                  "form",
                                  {
                                    on: {
                                      submit: function($event) {
                                        $event.preventDefault()
                                        return _vm.addComment.apply(
                                          null,
                                          arguments
                                        )
                                      }
                                    }
                                  },
                                  [
                                    _c(
                                      "md-field",
                                      {
                                        staticClass: "create-ask textareaAfter"
                                      },
                                      [
                                        _c("md-textarea", {
                                          staticClass:
                                            "md-textarea padding-left-10",
                                          attrs: {
                                            placeholder: "Enter your comment"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "md-field",
                                      { staticClass: "create-ask" },
                                      [
                                        _c(
                                          "md-button",
                                          {
                                            staticClass:
                                              "md-accent md-raised upper-word md-white-color",
                                            attrs: { type: "submit" }
                                          },
                                          [_vm._v("Add Comment")]
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ])
                            ])
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            )
          : _vm._e()
      ]
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-ddc99ffc", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ddc99ffc","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/IncompleteRequestDetail.vue
// module id = null
// module chunks = 